import { cn } from '@sohanemon/utils';
import { m } from '@sohanscript/i18n';
import { formatIndex, localizeDigits } from '@sohanscript/lib/utils/format';
import { Motion } from '@sohanscript/ui/motion';
import type * as React from 'react';
import type { Experience } from '#/lib/hooks/sohanemon.tsx';

type ExperienceTitleProps = React.ComponentProps<typeof Motion> & {
	item: Experience;
	index: number;
};

export function ExperienceTitle({
	className,
	item,
	index,
	...props
}: ExperienceTitleProps) {
	return (
		<Motion
			as="article"
			initial={{ scale: 0.5, y: -100, opacity: 0 }}
			animate={{ scale: 1, y: 0, opacity: 1 }}
			exit={{ scale: 0.5, y: 100, opacity: 0 }}
			transition={{ duration: 0.5, ease: 'easeInOut' }}
			className={cn(
				'absolute inset-x-0 flex h-96 origin-left flex-col justify-center',
				className,
			)}
			{...props}
		>
			<div className="mb-7 flex items-center gap-4">
				<span className="grid size-9 place-items-center border border-primary/40 bg-primary/10 font-mono text-primary text-xs">
					{formatIndex(index + 1)}
				</span>
				<span className="font-mono text-primary text-xs uppercase tracking-[0.28em]">
					{localizeDigits(item.period)}
				</span>
			</div>
			<h3 className="max-w-xl font-black font-display text-5xl text-foreground uppercase leading-[0.86] tracking-[-0.06em] md:text-6xl">
				{item.company}
			</h3>
			<p className="mt-6 font-semibold text-primary md:text-xl">{item.role}</p>
			<p className="mt-2 font-mono text-muted-foreground text-xs uppercase tracking-[0.25em]">
				{m.experience_location_remote({ location: item.location })}
			</p>
		</Motion>
	);
}
